import {
  types,
  PackType,
  ICreatePackAction,
  ICreatePackSuccessAction,
  IFailureAction,
  IGetPackByIdAction,
  IGetPackByIdSuccessAction,
  IUpdatePackAction,
  IUpdatePackPollingSuccessAction,
  IUpdatePackSuccessAction,
  IDeletePackAction,
  IDeletePackSuccessAction,
  IValidateSlugAction,
  IValidateSlugFinishedAction,
  FormObjectType,
  IDeleteFileAction,
  IDeleteFileSuccessAction,
  IDeleteFilePollingSuccessAction,
  IPublishPackAction,
  IPublishPackPollingSuccessAction,
  IPublishPackSuccessAction,
  ICheckPackBeingPublishedAction,
  IDeletePackPollingSuccessAction,
  IGetPackByIdNoUpdatesAction,
  IGetPackByIdShadowAction,
  ICleanupPackAction,
  ICreatePackFromFileSuccess,
  ICreatePackFromFile,
  ICreatePackFromDataStreamURI,
  EditionLanguage,
} from '../types/pack'
import { IPollingTaskData } from '../types/polling'

export const createPack = (packData: PackType): ICreatePackAction => ({
  type: types.CREATE_PACK__STARTED,
  packData,
})

export const createPackSuccess = (
  packData: PackType,
  message: string
): ICreatePackSuccessAction => ({
  type: types.CREATE_PACK__SUCCESS,
  packData,
  message,
})

export const createPackFromFile = (
  groupId: string,
  fileId: string
): ICreatePackFromFile => ({
  type: types.CREATE_PACK_FROM_FILE__STARTED,
  groupId,
  fileId,
})

export const createPackFromDataChartURI = (
  groupId: string,
  title: string,
  dataStreamURI: string
): ICreatePackFromDataStreamURI => ({
  type: types.CREATE_PACK_FROM_DATASTREAMURI__STARTED,
  groupId,
  title,
  dataStreamURI,
})

export const createPackFromFileSuccess = (groupId: string) => (
  data: IPollingTaskData
): ICreatePackFromFileSuccess => ({
  type: types.CREATE_PACK_FROM_FILE__SUCCESS,
  groupId,
  data,
})

export const createPackFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.CREATE_PACK__FAILURE,
  message,
  correlationId,
})

export const getPackById = (
  id: string,
  group?: string
): IGetPackByIdAction => ({
  type: types.GET_PACK_BY_ID__STARTED,
  id,
  group,
})

export const getPackByIdShadow = (id: string): IGetPackByIdShadowAction => ({
  type: types.GET_PACK_BY_ID__STARTED_SHADOW,
  id,
})

export const getPackByIdSuccess = (
  packData: PackType
): IGetPackByIdSuccessAction => ({
  type: types.GET_PACK_BY_ID__SUCCESS,
  packData,
})

export const getPackByIdNoUpdates = (): IGetPackByIdNoUpdatesAction => ({
  type: types.GET_PACK_BY_ID__NO_UPDATES,
})

export const getPackByIdFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.GET_PACK_BY_ID__FAILURE,
  message,
  correlationId,
})

export const updatePack = (packData: PackType): IUpdatePackAction => ({
  type: types.UPDATE_PACK__STARTED,
  packData,
})

export const updatePackPollingSuccess = (
  data: IPollingTaskData
): IUpdatePackPollingSuccessAction => ({
  type: types.UPDATE_PACK_POLLING__SUCCESS,
  data,
})

export const updatePackSuccess = (
  packData: PackType,
  message: string
): IUpdatePackSuccessAction => ({
  type: types.UPDATE_PACK__SUCCESS,
  packData,
  message,
})

export const updatePackFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.UPDATE_PACK__FAILURE,
  message,
  correlationId,
})

export const deletePack = (id: string): IDeletePackAction => ({
  type: types.DELETE_PACK__STARTED,
  id,
})

export const deletePackSuccess = (
  message: string
): IDeletePackSuccessAction => ({
  type: types.DELETE_PACK__SUCCESS,
  message,
})

export const deletePackPollingSuccess = (
  data: IPollingTaskData
): IDeletePackPollingSuccessAction => ({
  type: types.DELETE_PACK_POLLING__SUCCESS,
  data,
})

export const deletePackFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.DELETE_PACK__FAILURE,
  message,
  correlationId,
})

export const cleanupPack = (): ICleanupPackAction => ({
  type: types.CLEANUP_PACK,
})

export const validateSlug = (
  slug: string,
  language: EditionLanguage,
  changeSlugCallback: (value: string) => void,
  changeTopicsCodesCallback?: (value: FormObjectType[]) => void,
  onValidate?: () => void
): IValidateSlugAction => ({
  type: types.VALIDATE_SLUG__STARTED,
  slug,
  language,
  changeSlugCallback,
  changeTopicsCodesCallback,
  onValidate,
})

export const validateSlugFinished = (): IValidateSlugFinishedAction => ({
  type: types.VALIDATE_SLUG__SUCCESS,
})

export const deleteFile = (
  packId: string,
  fileId: string
): IDeleteFileAction => ({
  type: types.DELETE_FILE__STARTED,
  packId,
  fileId,
})

export const deleteFileSuccess = (
  message: string
): IDeleteFileSuccessAction => ({
  type: types.DELETE_FILE__SUCCESS,
  message,
})

export const deleteFileFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.DELETE_FILE__FAILURE,
  message,
  correlationId,
})

export const deleteFilePollingSuccess = (
  data: IPollingTaskData,
  options = {}
): IDeleteFilePollingSuccessAction => ({
  type: types.DELETE_FILE_POLLING__SUCCESS,
  data,
  options,
})

export const publishPack = (packData: PackType): IPublishPackAction => ({
  type: types.PUBLISH_PACK__STARTED,
  packData: {
    ...packData,
    publishing: { ...packData.publishing, publish: true },
  },
})

export const publishPackPollingSuccess = (
  data: IPollingTaskData
): IPublishPackPollingSuccessAction => ({
  type: types.PUBLISH_PACK_POLLING__SUCCESS,
  data,
})

export const publishPackSuccess = (
  packData: PackType
): IPublishPackSuccessAction => ({
  type: types.PUBLISH_PACK__SUCCESS,
  packData,
})

export const publishPackFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.PUBLISH_PACK__FAILURE,
  message,
  correlationId,
})

export const checkPackBeingPublished = (): ICheckPackBeingPublishedAction => ({
  type: types.CHECK_PACK_BEING_PUBLISHED,
})
